module.exports = __webpack_public_path__ + "static/media/raduno2015.a04143d3.jpg";